module.exports = __webpack_public_path__ + "img/hc_pro_seven_5.a58f731f.jpg";